<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">Links</v-subheader>
        <v-divider/>
        <px-circular-loading v-if="loading"/>
        <px-lista-links class="mb-4 mx-2" :links="links" :loading="loading"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AprovacaoSolicitacaoService
  from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  methods: {
    getLinks() {
      this.loading = true;
      AprovacaoSolicitacaoService.getLinks(this.aprovacao.id)
        .then(({ data }) => {
          this.links = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
};
</script>
